import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  selectIPFSApiKeysActionLoading,
  selectSelectedIpfsApiKey,
  selectShowEditorModal,
  handleHideEditorModal,
  createIpfsApiKeyAsync,
  updateIpfsApiKeyAsync,
  getIpfsApiKeysAysnc,
} from "../../../store/ipfs/apiKeysSlice";
import { IpfsApiKeySchema } from "../../../utils/validations";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useCallback, useEffect } from "react";
import { Modal, Button, Input } from "djuno-design";

const ApiKeyEditorModal = () => {
  const isOpen = useAppSelector(selectShowEditorModal);
  const loading = useAppSelector(selectIPFSApiKeysActionLoading);
  const apiKey = useAppSelector(selectSelectedIpfsApiKey);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(IpfsApiKeySchema),
  });

  useEffect(() => {
    if (isOpen && apiKey) {
      setValue("label", apiKey.Label);
    }
  }, [isOpen, apiKey, setValue]);

  const onSubmit = (data: any) => {
    if (!loading) {
      if (apiKey) {
        dispatch(
          updateIpfsApiKeyAsync({
            id: apiKey.Id,
            formData: {
              label: data.label,
            },
          })
        ).then((action) => {
          if (action.type === "ipfs/api-keys/update/fulfilled") {
            reset();
            dispatch(handleHideEditorModal());
            dispatch(getIpfsApiKeysAysnc());
          }
        });
      } else {
        dispatch(createIpfsApiKeyAsync({ label: data.label })).then(
          (action) => {
            if (action.type === "ipfs/api-keys/create/fulfilled") {
              reset();
              dispatch(handleHideEditorModal());
              dispatch(getIpfsApiKeysAysnc());
            }
          }
        );
      }
    }
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleHideEditorModal());
    reset();
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      title={apiKey ? "Update API key" : "Create new API key"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          <Input
            label="API key label"
            {...register("label")}
            error={errors.label?.message}
            placeholder=""
            required
          />
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            loading={loading}
            uiType="primary"
            type="submit"
            className="w-[100px]"
          >
            {apiKey ? "Update" : "Create"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ApiKeyEditorModal;
